import React, {useEffect, useState} from 'react';
import { useCookies } from "react-cookie";
import configVars from "../../config";
import UserCards from './UserCards';
import BillingHistory from './BillingHistory';

const Billing = (props) => {

    const [cookies] = useCookies(["sustainyou_user_jwt"]);
    const [stripeData, setStripeData] = useState({});
    const [loading, setLoading] = useState(false);
    const [isError, setIsError] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');

    useEffect(() => {

        (async () => {

            setLoading(true);

            setErrorMsg('');
            setIsError(false);

            let userRequestData = new FormData();
            userRequestData.append( 'token', cookies.sustainyou_user_jwt );

            const fetchUrl = `${configVars.apiUrl}sustainchange/v1/getstripedata/`;

            try{

                const response = await fetch(
                    fetchUrl,
                    {
                    method: "POST",
                    headers: {
                        Authorization: `Basic ${configVars.auth}`,
                    },
                    body: userRequestData
                    }
                );
                
                const updateResponse = await response.json();
        
                if ( updateResponse ) {

                    if (  updateResponse.success === true ) {
                        setStripeData( updateResponse.data );
                    }

                    if ( updateResponse.success === false ) {
                        setErrorMsg(updateResponse.message);
                        setIsError(true);
                    }

                }

                setLoading(false);

            } catch( error ) {
                console.log( error );
                return error;
            }

        })()

    }, [cookies.sustainyou_user_jwt]);

    return (
        <div className="billing-wrap">
            <div className="mx-auto" style={{maxWidth: '800px'}}>

                {isError && (
                    <div className="my-3 w-100">
                        <div className="alert alert-secondary" role="alert">
                            {errorMsg}
                        </div>
                    </div>
                )}

                { loading &&
                    <div className="d-flex mb-4 justify-content-center">
                        <div className="spinner-border" role="status" >
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                }

                { !loading && !isError &&
                    <>
                        <div className="border-top py-2 py-lg-3 mb-5">
                            <UserCards paymentMethods={stripeData.payment_methods} customerID={stripeData.customer_id} defaultPm={props?.defaultPm} subID={props?.subID} />
                        </div>
                        <div className="border-top py-2 py-lg-3 mb-5">
                            <BillingHistory stripeData={stripeData} />
                        </div>
                    </>
                }
            </div>
        </div>
    );
}

export default Billing;